// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueStrap from 'vue-strap'
import App from './App.vue'
// import cloudinary from 'cloudinary'
import Components from 'components'
import store from './store'
import router from './routes'
import { installRouterGuards } from './routes/guards'
import CommonFilters from './filters'
import moment from 'moment'
import CommonDirectives from 'directives'
import BootstrapElementUI from 'utils/elementui-bootstrap'
import money from 'v-money'
import VueRx from 'vue-rx'
import Rx from 'rxjs'
import VuePusher from 'plugins/pusher'
import VueFeatureFlags from 'plugins/feature-flags'
import VuePerms from 'plugins/perms'
import Versions from 'plugins/versions'
import ReadMore from 'vue-read-more'
import VueMq from 'vue-mq'
import VueBoard from './vue-board'
import VueCompositionApi from '@vue/composition-api'
import Bars from 'vuebars'
import VueApexCharts from 'vue-apexcharts'
import VueWaypoint from 'vue-waypoint'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import '@/assets/css/tailwind.css'

if (process.env.SENTRY_DSN) {
  console.log(` => SENTRY_DSN: ${process.env.SENTRY_DSN}`)

  const options = {
    dsn: process.env.SENTRY_DSN,
    environment: process.env.SENTRY_ENV || 'localdev',
    Vue,
    attachProps: true,
    tracingOptions: {
      trackComponents: true,
    },
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  }

  if (process.env.GIT_REV) {
    options.release = 'vestbee-app' + process.env.GIT_REV
  }

  Sentry.init(options)
  console.info('Sentry setup completed')
} else {
  console.warn('no SENTRY_DSN found, will NOT setup sentry')
}

if (window) {
  window.Sentry = Sentry
}

Vue.component('Apexchart', VueApexCharts)

Vue.use(ReadMore)
Vue.use(Vuex)
Vue.use(VueFeatureFlags)
Vue.use(VuePerms)
Vue.use(VueRouter)
Vue.use(VueStrap)
Vue.use(VueRx, Rx)
Vue.use(CommonFilters)
Vue.use(CommonDirectives)
Vue.use(BootstrapElementUI)
Vue.use(VueWaypoint)
Vue.use(money, {
  precision: 0,
  suffix: ' €',
  decimal: '.',
  thousands: ' ',
})
Vue.use(VueMq, {
  breakpoints: {
    'break-xs': 415,
    'break-small': 769,
    'break-medium': 1201,
    'break-large': 1441,
  },
})
Vue.use(VueBoard)
Vue.use(VueCompositionApi)
Vue.use(Bars)
Vue.component('MainApp', App)

if (process.env.PUSHER_KEY) {
  console.log(' => pusher plugin: enabled')
  Vue.use(VuePusher, {
    apiKey: process.env.PUSHER_KEY,
  })
} else {
  console.log(' => pusher plugin: disabled (no PUSHER_KEY env var found)')
}

Components.registerCommonComponents()

Vue.config.ignoredElements = ['ion-icon']

Vue.config.keyCodes = {
  comma: 188,
}

installRouterGuards({ router, store })

const app = new Vue({
  router,
  store,
  el: '#app',
  async created() {
    console.log(' => bootstrapping done')
    this.$store.dispatch('common/fetch')
    const user = await this.$store.dispatch('user/getUser')
    if (user && user.id) {
      Sentry.setUser({ id: user.id })
    }
  },
})

Vue.use(Versions, { app, store })

window.vue = app
window.addEventListener(
  'dragover',
  function (e) {
    // e = e || event;
    e.preventDefault()
  },
  false,
)
window.addEventListener(
  'drop',
  function (e) {
    // e = e || event;
    e.preventDefault()
  },
  false,
)
window.Vue = Vue

window.moment = moment
window.Rx = Rx

// cloudinary.setCloudName('vestbee')
